import React from 'react';
import CategoryTile from 'scy/CategoryTile';
import { TextHR } from 'scy/HR';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

const categories = [
  { name: 'Beer', tag: 'BE' },
  { name: 'Wine', tag: 'WN' },
  { name: 'Spirits', tag: 'ST' },
  { name: 'More', tag: 'OT' }
];

export default function BrowseMore({ headingText = 'Browse By Category' }) {
  return (
    <React.Fragment>
      <TextHR className={margin.bottom_md}>{headingText}</TextHR>
      <div className={styles.categories}>
        {categories.map(category => (
          <CategoryTile
            key={category.name}
            linkClassName={styles.container}
            backgroundClassName={styles.background}
            category={category}
          />
        ))}
      </div>
    </React.Fragment>
  );
}
